import React from "react";
import { motion } from "framer-motion";
import PogLogo from "./PogLogo";

const Hero = () => {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen overflow-hidden"
    >
      {/* Bright sunburst — the brand's signature */}
      <div className="absolute inset-0 sunburst" />
      {/* Gentle vignette so type stays legible */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#7A1F0E]/10 to-[#2B1D15]/30" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#14100D]/25 via-transparent to-transparent" />

      {/* Grain */}
      <div className="absolute inset-0 grain pointer-events-none" />

      <div className="relative z-10 max-w-[1400px] mx-auto px-8 md:px-16 pt-40 pb-24 min-h-screen flex flex-col">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, delay: 0.3 }}
          className="flex items-center gap-5"
          data-testid="hero-overline"
        >
          <span className="counter text-[#FBF3E4]/85">01 — Aloha</span>
          <span className="w-16 h-px bg-[#FBF3E4]/40 inline-block" />
          <span className="overline !text-[#FBF3E4]/85">Made in Hawai‘i · Est. 1971</span>
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.4, delay: 0.5 }}
          className="display-tight text-[#FBF3E4] mt-16 text-[3.75rem] sm:text-[6rem] md:text-[9rem] xl:text-[11rem] max-w-[1200px] drop-shadow-[0_6px_24px_rgba(122,31,14,0.35)]"
          data-testid="hero-headline"
        >
          Icons evolve.
          <br />
          <span className="italic font-light text-[#FBF3E4]/95">So we did.</span>
        </motion.h1>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.1, delay: 0.9 }}
          className="mt-14 max-w-2xl"
          data-testid="hero-subtitle"
        >
          <div className="font-body text-2xl md:text-3xl text-[#FBF3E4] leading-[1.4] flex flex-wrap items-center gap-x-3 gap-y-2 font-light drop-shadow-[0_3px_12px_rgba(122,31,14,0.35)]">
            <span>Welcome to</span>
            <PogLogo size={44} className="md:!h-[56px] drop-shadow-[0_6px_18px_rgba(0,0,0,0.35)]" />
            <span>Vodka and Ready to Drink in a Can.</span>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 1.3 }}
          className="mt-auto pt-20 flex flex-wrap items-end justify-between gap-8"
        >
          <div className="flex gap-4">
            <button
              onClick={() => document.getElementById("products")?.scrollIntoView({ behavior: "smooth" })}
              className="btn-primary is-solid !border-[#14100D] !bg-[#14100D] !text-[#FBF3E4]"
              data-testid="hero-cta-products"
            >
              Meet The Bottle
            </button>
            <button
              onClick={() => document.getElementById("story")?.scrollIntoView({ behavior: "smooth" })}
              className="btn-ghost !text-[#FBF3E4] !border-[#FBF3E4]/60 hover:!bg-[#FBF3E4] hover:!text-[#14100D]"
              data-testid="hero-cta-story"
            >
              The Story
            </button>
          </div>

          <div className="text-[#FBF3E4]/90 font-body text-xs tracking-[0.15em] uppercase max-w-xs text-right">
            <div className="mb-2 text-[#FBF3E4] font-medium">In Partnership with Meadow Gold</div>
            <div className="text-[10px] leading-relaxed normal-case tracking-normal font-body text-base text-[#FBF3E4]/85 font-light">
              An independent spirits brand — inspired by the iconic 1971 Hawaiian juice.
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
